module.exports = __webpack_public_path__ + "static/media/icon-search.14de82eb.svg";